export default "__VITE_ASSET__Dtal87IB__"